import axios, { AxiosResponse } from 'axios';

// /ewosapi/v1/scenarios/gt2-multi/run
export const runScenario = async (globalCompanyId: string, scenarioId: string): Promise<AxiosResponse> => {
  return await axios.post(`/ewosapi/v1/scenarios/gt2-multi/run?globalCompanyId=${globalCompanyId}&scenarioId=${scenarioId}`);
};
